
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { defineProperty as _defineProperty, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import AsyncSelect$1 from '../../../../node_modules/react-select/async/dist/react-select-async.esm.js';
import StateManagedSelect$1 from '../../../../node_modules/react-select/dist/react-select.esm.js';
import CreatableSelect$1 from '../../../../node_modules/react-select/creatable/dist/react-select-creatable.esm.js';
import SvgIconCaretRight from '../../../icons/carets/icon-caret-right.svg.js';
import { customLabelStyles } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["loadOptions"];
var containerClassNames = function containerClassNames(status, size) {
  return classNames(_defineProperty(_defineProperty(_defineProperty({}, "control-".concat(size), true), "valid", status === "valid"), "error", status === "error"));
};
var formatOptionLabel = function formatOptionLabel(_ref, _ref2) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level;
  var context = _ref2.context;
  if (!level || context === "value") return jsx(React__default.Fragment, null, label);
  var isRtl = document.dir === "rtl";
  var rotation = isRtl ? 180 : 0;
  return jsx("span", {
    css: function css() {
      return customLabelStyles({
        level: level
      });
    }
  }, level ? jsx(SvgIconCaretRight, {
    height: 10,
    style: {
      transform: "rotate(".concat(rotation, "deg)")
    }
  }) : null, jsx("span", null, label));
};
var renderSelect = function renderSelect(type, customSelectProps) {
  var loadOptions = customSelectProps.loadOptions,
    rest = _objectWithoutProperties(customSelectProps, _excluded);
  switch (type) {
    case "creatable":
      return jsx(CreatableSelect$1, _extends({}, rest, {
        createOptionPosition: "first",
        formatOptionLabel: formatOptionLabel
      }));
    case "async":
      return jsx(AsyncSelect$1, _extends({}, rest, {
        loadOptions: loadOptions
      }));
    default:
      return jsx(StateManagedSelect$1, _extends({}, rest, {
        formatOptionLabel: formatOptionLabel
      }));
  }
};

export { containerClassNames, formatOptionLabel, renderSelect };
//# sourceMappingURL=helpers.js.map
